export const videoPLayerStateKey = Symbol();
